import Cookies from "universal-cookie";

const cookies = new Cookies();
export const get_Token = () => {
    if(cookies.get('admin_rueda')){
        return cookies.get('admin_rueda')
    }else{
        window.location.href='/'
    }
}